/* took2 cart live refresh for topbar */
(function(){
  var root = document.querySelector('#t2-gta-shop');
  if(!root) return;
  var countEl = root.querySelector('[data-cart-count]');
  var totalEl = root.querySelector('[data-cart-total]');
  var locale = document.documentElement.lang || 'en';
  var currency = (root.getAttribute('data-currency') || '').trim();

  function money(cents){
    var value = (cents||0)/100;
    try { return value.toLocaleString(locale, {style:'currency', currency: currency || 'EUR'}); }
    catch(e){ return value.toFixed(2) + ' ' + (currency||'EUR'); }
  }
  function refresh(){
    fetch('/cart.js',{credentials:'same-origin'})
      .then(r=>r.json())
      .then(c=>{
        if(countEl) countEl.textContent = c.item_count;
        if(totalEl) totalEl.textContent = money(c.total_price);
      }).catch(()=>{});
  }
  document.addEventListener('DOMContentLoaded', refresh);
  document.body.addEventListener('submit', function(e){
    var f = e.target;
    if(f && f.action && f.action.indexOf('/cart/add')!==-1) setTimeout(refresh,700);
  }, true);
  document.addEventListener('cart:refresh', refresh);
})();
/* took2: mark contact page for robust CSS targeting */
(function () {
  function markContact() {
    if (document.querySelector('form[action*="/contact"]') ||
        document.querySelector('form[id*="ContactForm"], .contact-form')) {
      document.body.classList.add('t2-contact-page');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markContact);
  } else {
    markContact();
  }
})();
